import { createBrowserRouter, Navigate } from "react-router-dom";

import GuestRoute from "@/app/GuestRoute";
import ProtectedRoute from "@/app/ProtectedRoute";

import ResponsiveLayout from "@/components/layout/ResponsiveLayout";

import AuthPage from "@/pages/auth/AuthPage";
import NotFoundPage from "@/pages/not-found/NotFoundPage";

import InventoryPage from "@/pages/inventory/InventoryPage";

import PurchaseTicketPage from "@/pages/purchase-ticket/PurchaseTicketPage";
import SelectTripPage from "@/pages/purchase-ticket/SelectTripPage";
import ContactInfoPage from "@/pages/purchase-ticket/ContactInfoPage";
import BookingSummaryPage from "@/pages/purchase-ticket/BookingSummaryPage";
import BookingConfirmationPage from "@/pages/purchase-ticket/BookingConfirmationPage";

import ProfilePage from "@/pages/profile/ProfilePage";
import ChangePasswordPage from "@/pages/profile/ChangePasswordPage";

import TopupPage from "@/pages/topup/TopupPage";
import TopupDetailsPage from "@/pages/topup/TopupDetailsPage";
import TopupConfimationPage from "@/pages/topup/TopupConfimationPage";

import TopupHistoryPage from "@/pages/topup-history/TopupHistoryPage";
import TopupHistoryDetailPage from "@/pages/topup-history/TopupHistoryDetailPage";

import BookingHistoryPage from "@/pages/booking-history/BookingHistoryPage";
import BookingDetailsPage from "@/pages/booking-history/BookingDetailsPage";
import EditContactDetailsPage from "@/pages/booking-history/EditContactDetailsPage";
import AddPassengerDetailsPage from "@/pages/booking-history/AddPassengerDetailsPage";
import VerifyTdaPage from "@/pages/purchase-ticket/VerifyTdaPage";

export const router = createBrowserRouter([
  // ============================================================
  // Public Routes
  // ============================================================

  {
    element: <GuestRoute />,
    children: [
      {
        path: "/",
        element: <Navigate to="/auth" replace />,
      },
      {
        path: "/auth",
        element: <AuthPage />,
      },
    ],
  },

  // ============================================================
  // Protected Routes
  // ============================================================

  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <ResponsiveLayout />,
        children: [
          // ------------------------------------------------------
          // Inventory
          // ------------------------------------------------------

          {
            path: "/inventory",
            element: <InventoryPage />,
          },

          // ------------------------------------------------------
          // Purchase Ticket
          // ------------------------------------------------------

          {
            path: "/purchase-ticket",
            children: [
              {
                index: true,
                element: <PurchaseTicketPage />,
              },
              {
                handle: {
                  hideTopHero: true,
                },
                children: [
                   {
                    path: "verify-tda",
                    element: <VerifyTdaPage />,
                  },
                  {
                    path: "select-trip",
                    element: <SelectTripPage />,
                  },
                  {
                    path: "contact-info",
                    element: <ContactInfoPage />,
                  },
                  {
                    path: "booking-summary/:paymentId",
                    element: <BookingSummaryPage />,
                  },
                  {
                    path: "booking-confirmation",
                    element: <BookingConfirmationPage />,
                  },
                ],
              },
            ],
          },

          // ------------------------------------------------------
          // Top Up
          // ------------------------------------------------------

          {
            path: "/top-up",
            children: [
              {
                index: true,
                element: <TopupPage />,
              },
              {
                handle: {
                  hideTopHero: true,
                },
                children: [
                  {
                    path: "top-up-details",
                    element: <TopupDetailsPage />,
                  },
                  {
                    path: "top-up-confirmation/:topupno",
                    element: <TopupConfimationPage />,
                  },
                ],
              },
            ],
          },

          // ------------------------------------------------------
          // Profile
          // ------------------------------------------------------

          {
            path: "/profile",
            children: [
              {
                index: true,
                element: <ProfilePage />,
              },
              {
                handle: {
                  hideTopHero: true,
                },
                children: [
                  {
                    path: "change-password",
                    element: <ChangePasswordPage />,
                  },
                ],
              },
            ],
          },

          // ------------------------------------------------------
          // Top Up History
          // ------------------------------------------------------

          {
            path: "/topup-history",
            children: [
              {
                index: true,
                element: <TopupHistoryPage />,
              },
              {
                handle: {
                  hideTopHero: true,
                },
                children: [
                  {
                    path: ":topUpNo",
                    element: <TopupHistoryDetailPage />,
                  },
                ],
              },
            ],
          },

          // ------------------------------------------------------
          // Booking History
          // ------------------------------------------------------

          {
            path: "/booking-history",
            children: [
              {
                index: true,
                element: <BookingHistoryPage />,
              },
              {
                handle: {
                  hideTopHero: true,
                },
                children: [
                  {
                    path: ":paymentId",
                    element: <BookingDetailsPage />,
                  },
                  {
                    path: ":paymentId/contact",
                    element: <EditContactDetailsPage />,
                  },
                  {
                    path: "passenger/:paymentId",
                    element: <AddPassengerDetailsPage />,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },

  // ============================================================
  // 404
  // ============================================================

  {
    path: "*",
    element: <NotFoundPage />,
  },
]);
